import { createBrowserRouter } from "react-router-dom";
import FormBuilderPage from "./pages/FormBuilderPage";
import FormDirectoryPage from "./pages/FormDirectoryPage";
import FormPreviewPage from "./pages/FormPreviewPage";
import TeamSettingsPage from "./pages/TeamSettingsPage";
import FormAnalyticsPage from "./pages/FormAnalyticsPage";
import TeamThemesPage from "./pages/TeamThemesPage";
import TeamMembersPage from "./pages/TeamMembersPage";
import TeamInvitationsPage from "./pages/TeamInvitationsPage";
import TeamDomainsPage from "./pages/TeamDomainsPage";
import AdminTeamsPage from "./pages/AdminTeamsPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import UserAccountPage from "./pages/UserAccountPage";
import PrivacyPage from "./pages/PrivacyPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import FormVersionsPage from "./pages/FormVersionsPage";
import FormSharingPage from "./pages/FormSharingPage";
import TeamSharingPage from "./pages/TeamSharingPage";
import FormFileManagementPage from "./pages/FormFileManagementPage";
import FormThemeEditorPage from "./pages/FormThemeEditorPage";
import FormResponsesPage from "./pages/FormResponsesPage";
import SharePage from "./pages/SharePage";
import ProtectedRoute from "./components/ProtectedRoute";
import AppLayout from "./components/AppLayout";
import SharePageErrorBoundary from "./components/SharePageErrorBoundary";


export const router = createBrowserRouter([
  {
    path: "/login",
    element: (
      <AppLayout>
        <LoginPage />
      </AppLayout>
    ),
  },
  {
    path: "/register",
    element: (
      <AppLayout>
        <RegisterPage />
      </AppLayout>
    ),
  },
  {
    path: "/",
    element: (
      <AppLayout>
        <ProtectedRoute>
          <FormDirectoryPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/teams/:teamId",
    element: (
      <AppLayout>
        <ProtectedRoute>
          <FormDirectoryPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/teams/:teamId/forms/:formId",
    element: (
      <AppLayout>
        <ProtectedRoute>
          <FormBuilderPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/teams/:teamId/forms/:formId/preview",
    element: (
      <AppLayout>
        <ProtectedRoute>
          <FormPreviewPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/teams/:teamId/forms/:formId/analytics",
    element: (
      <AppLayout>
        <ProtectedRoute>
          <FormAnalyticsPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/teams/:teamId/forms/:formId/responses",
    element: (
      <AppLayout>
        <ProtectedRoute>
          <FormResponsesPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/teams/:teamId/settings",
    element: (
      <AppLayout>
        <ProtectedRoute requireRoles={["TeamAdmin", "SuperAdmin"]}>
          <TeamSettingsPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/teams/:teamId/themes",
    element: (
      <AppLayout>
        <ProtectedRoute>
          <TeamThemesPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/teams/:teamId/members",
    element: (
      <AppLayout>
        <ProtectedRoute>
          <TeamMembersPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/teams/:teamId/invitations",
    element: (
      <AppLayout>
        <ProtectedRoute requireRoles={["TeamAdmin", "SuperAdmin"]}>
          <TeamInvitationsPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/teams/:teamId/domains",
    element: (
      <AppLayout>
        <ProtectedRoute requireRoles={["TeamAdmin", "DomainManager", "SuperAdmin"]}>
          <TeamDomainsPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/admin/teams",
    element: (
      <AppLayout>
        <ProtectedRoute requireRoles={["SuperAdmin"]}>
          <AdminTeamsPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/admin/users",
    element: (
      <AppLayout>
        <ProtectedRoute requireRoles={["SuperAdmin"]}>
          <AdminUsersPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/account",
    element: (
      <AppLayout>
        <ProtectedRoute>
          <UserAccountPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/privacy",
    element: (
      <AppLayout>
        <ProtectedRoute>
          <PrivacyPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/teams/:teamId/forms/:formId/versions",
    element: (
      <AppLayout>
        <ProtectedRoute>
          <FormVersionsPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/teams/:teamId/forms/:formId/sharing",
    element: (
      <AppLayout>
        <ProtectedRoute>
          <FormSharingPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/teams/:teamId/forms/:formId/files",
    element: (
      <AppLayout>
        <ProtectedRoute>
          <FormFileManagementPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/teams/:teamId/forms/:formId/theme",
    element: (
      <AppLayout>
        <ProtectedRoute>
          <FormThemeEditorPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/teams/:teamId/sharing",
    element: (
      <AppLayout>
        <ProtectedRoute>
          <TeamSharingPage />
        </ProtectedRoute>
      </AppLayout>
    ),
  },
  {
    path: "/share/:token",
    element: (
      <SharePageErrorBoundary>
        <SharePage />
      </SharePageErrorBoundary>
    ),
  },
]);
